import { render, staticRenderFns } from "./PortalFields.vue?vue&type=template&id=43882e50&"
import script from "./PortalFields.vue?vue&type=script&lang=js&"
export * from "./PortalFields.vue?vue&type=script&lang=js&"
import style0 from "./PortalFields.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports